import { useMemo } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from '../LookingForSomethingElse/constants'
import { isManualSortingEnabledFor } from 'selectors/featuresSelectors'
import OfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'

const OFFER_TYPES: Array<App.OfferListOfferType> = ['hotel', 'tactical_ao_hotel', 'tour', 'tour_v2']
const DEFAULT_PUBLIC_OFFER_PARAMS: App.OfferListFilters = {
  offerTypes: OFFER_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  propertySubCategories: ['Ultra Lux'],
  sortBy: 'homepage',
}
const DEFAULT_UNIFIED_ENDPOINT_PARAMS: App.OfferListFilters = {
  offerTypes: OFFER_TYPES,
  limit: MAX_CAROUSEL_ITEM_COUNT,
  holidayTypesScoped: ['Ultra Lux'],
  sortBy: 'vertical-ultralux',
}
interface Props {
  title?: React.ReactNode
  minimumOffersCount?: number
}

function UltraLuxOfferCarousel(props: Props) {
  const { title, minimumOffersCount } = props
  const intl = useIntl()
  const isManualSortingEnabled = isManualSortingEnabledFor('ultralux')
  const filters = isManualSortingEnabled ? DEFAULT_UNIFIED_ENDPOINT_PARAMS : DEFAULT_PUBLIC_OFFER_PARAMS

  const defaultTitle = useMemo(
    () =>
      intl.formatMessage(
        {
          id: '3dM6IEzjxGRKvRLxx_BM',
          defaultMessage: 'Indulge in <i>ultra lux</i> escapes',
          description: 'Title for Ultra Lux carousel with italicized ultra lux',
        },
        {
          i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
        },
      ),
    [intl],
  )

  return (
    <OfferCardCarouselSection
      filters={filters}
      title={title ?? defaultTitle}
      allLink="/ultra-lux"
      additionalFilters="holidayTypes"
      tileStyle="card-default"
      tileSize="medium"
      minimumOffersCount={minimumOffersCount}
      data-testid="ultralux-carousel"
    >
      <OfferCarouselLookingForSomethingElse to={LOOKING_FOR_SOMETHING_ELSE_CONTENT.ultralux.to} />
    </OfferCardCarouselSection>
  )
}

export default React.memo(UltraLuxOfferCarousel)
